let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("ffEVr"), load("6KHMO")]).then(() => parcelRequire('2jPbz'));